(function ($) {
    $(document).ready(function () {
        $('.__select').click(function () {
            if ($('.__select').attr("data-state") == 'false') {
                $(this).attr("data-state", "active");
            } else {
                $(this).attr("data-state", 'false');
            }
        })
        $('.__select__label').click(function () {
            $('.__select__input').removeClass('checked');
            const input = $(this).attr('for');
            const teamColor = !$('.name', this).text().toString().includes(' ') ? $('.name', this).text().toString() : $('.name', this).text().toString().replace(' ', '');
            $('#' + input).addClass('checked');
            $('.__select__title.team-color .color').css('backgroundColor', $('.color', this).css('backgroundColor'));
            $('.__select__title.team-color .name').text($('.name', this).text());
            $('.__select').attr("data-state", 'false');
            $('.team-colors-tab-container').css('display', 'none');
            $('#name_color_' + teamColor.toLowerCase()).css('display', 'block');
        })
        $('.team-colors-radio .team-color').click(function () {
            $('.team-colors-radio input').removeClass('checked');
            const input = $(this).attr('for');
            const teamColor = !$('.name', this).text().toString().includes(' ') ? $('.name', this).text().toString() : $('.name', this).text().toString().replace(' ', '');
            $('#' + input).addClass('checked');
            $('.team-colors-tab-container').css('display', 'none');
            $('#name_color_' + teamColor.toLowerCase()).css('display', 'block');
        })
    })
})(jQuery)